export default {
  getCsvOrder: (state) => state.csvOrder,
};
